import React, { FC } from 'react';
import { Typography } from '@mui/material';
import { themePalette } from '@theme/muiTheme';
import {
  NavLinkContent,
  StyledNavLink,
} from '@views/Project/components/Toolbox/components/LinkButton/LinkButton.styled';

type Props = {
  item: {
    label: string;
    to: string;
    Icon: React.ElementType;
  };

  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
};

const LinkButton: FC<Props> = ({ item, onClick }) => {
  const { label, to, Icon } = item;

  return (
    <StyledNavLink to={to} key={label} onClick={onClick}>
      {({ isActive }) => {
        return (
          <NavLinkContent $isActive={isActive}>
            <Icon
              fill={themePalette.grey[isActive ? 1000 : 800]}
              width={21}
              height={21}
            />

            <Typography
              variant="h3"
              color={isActive ? 'grey.1000' : 'grey.800'}
              sx={{ ml: 1 }}
            >
              {label}
            </Typography>
          </NavLinkContent>
        );
      }}
    </StyledNavLink>
  );
};

export default LinkButton;
